import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class AppSettings {
  public static BASE = '';

  constructor(@Inject(DOCUMENT) private document: Document) {
    AppSettings.BASE =
      document.location.protocol + '//' + document.location.hostname;

    // config asun
    
    // config local
    if (document.location.hostname == 'localhost') {
      AppSettings.API_ENDPOINT = 'http://127.0.0.1:8000/api/';
    }
  }

  // ng build --prod --build-optimizer=true

  // config default
  //public static ROOT_ENDPOINT = AppSettings.BASE;
  //public static API_ENDPOINT = 'http://localhost/api/api/';

  public static API_ENDPOINT = 'https://api.wotica.com.br/api/';
  public static ROOT_ENDPOINT = 'https://painel.wotica.com.br/';
  public static VENDA_ENDPOINT = 'https://venda.wotica.com.br/';

  public static URL_IMG_OFERTA ='//superimg2.s3.sa-east-1.amazonaws.com/img.ofertas/';
  public static URL_S3_IMG_PRODUTO =
    '//superimg2.s3.sa-east-1.amazonaws.com/img.produtos/';
  public static URL_IMG_PRODUTO =
    '//superimg2.s3.sa-east-1.amazonaws.com/img.produtos/';
  public static URL_IMG_ESTABELECIMENTO =
    '//superimg2.s3.sa-east-1.amazonaws.com/img.estabelecimentos/';
  public static URL_IMG_OPERADORES =
    '//superimg2.s3.sa-east-1.amazonaws.com/img.operadores/';
}
